if (!customElements.get("countdown-timer")) {
  customElements.define(
    "countdown-timer",
    class CountdownTimer extends HTMLElement {
      endDateString = null;
      endDate = null;
      days = null;
      hrs = null;
      mins = null;
      secs = null;
      rafId = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.endDate = this.convertToPST(this.dataset.endDate);
        //  console.log(this.endDate);
        if (isNaN(this.endDate)) {
          console.error("[Countdown Timer] Invalid end date.");
          return;
        }

        this.days = this.querySelector("[data-days]");
        this.hrs = this.querySelector("[data-hrs]");
        this.mins = this.querySelector("[data-mins]");
        this.secs = this.querySelector("[data-secs]");

        this.tick();
      }

      tick = () => {
        const now = this.convertToPST(new Date());

        if (now >= this.endDate) {
          // Countdown ended
          this.updateDisplay({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          this.style.display = "none";
          // Cancel animation when countdown ends
          cancelAnimationFrame(this.rafId);
        } else {
          // Active countdown
          this.style.display = "block";
          this.updateDisplay(this.getTimeRemaining(this.endDate));
        }

        this.rafId = requestAnimationFrame(this.tick);
      };

      getTimeRemaining(endTime) {
        const total = endTime - this.convertToPST(new Date()).getTime();

        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));

        return {
          days: Math.max(0, days),
          hours: Math.max(0, hours),
          minutes: Math.max(0, minutes),
          seconds: Math.max(0, seconds),
        };
      }

      convertToPST(dateString) {
       
/*
        let date;
        if (dateString.length <= 10) {
          date = new Date(dateString + "T00:00:00-05:00");
        } else {
          date = new Date(dateString);
        }
*/
        return new Date(dateString);
      }

      updateDisplay({ days, hours, minutes, seconds }) {
        this.days.querySelector(".number").textContent = days;
        this.hrs.querySelector(".number").textContent = hours;
        this.mins.querySelector(".number").textContent = String(
          minutes,
        ).padStart(2, "0");
        this.secs.querySelector(".number").textContent = String(
          seconds,
        ).padStart(2, "0");

        if (days <= 0) {
          this.days.style.display = "none";
        }

        if (days <= 0 && hours <= 0) {
          this.hrs.style.display = "none";
        }

        if (days <= 0 && hours <= 0 && minutes <= 0) {
          this.mins.style.display = "none";
        }
      }

      disconnectedCallback() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
      }
    },
  );
}
